import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormLabel,
    HStack,
    Input,
    Select,
    Spacer,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    VStack,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../../stores/pipeline-store';
import { OPERATION } from '../constants';
import { VarSelect } from '../inputs';

type SetVarStepSettingsProps = {
    stepId: string;
};
export function SetVarStepSettings({ stepId }: SetVarStepSettingsProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as SetVarStep;
    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel>Operation type</FormLabel>
                <Select
                    color={'black'}
                    value={step.operationType}
                    backgroundColor="white"
                    onChange={({ target: { value } }: any) => {
                        updateStep(stepId, 'operationType', value);
                    }}
                >
                    <option value="map" disabled={false}>
                        Map
                    </option>
                    <option value="numeric" disabled={false}>
                        Numeric calculation
                    </option>
                    <option value="extract-json-string-value" disabled={false}>
                        Extract json string value
                    </option>
                </Select>
            </FormControl>
            {step.operationType === 'map' ? (
                <>
                    <FormControl>
                        <FormLabel>Source Var</FormLabel>
                        <VarSelect
                            value={step.sourceVarId}
                            filterByType={['STRING']}
                            onChange={(value) => updateStep(stepId, 'sourceVarId', value)}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Target Var</FormLabel>
                        <VarSelect
                            value={step.targetVarId}
                            filterByType={['STRING']}
                            onChange={(value) => updateStep(stepId, 'targetVarId', value)}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Default Value</FormLabel>
                        <Input
                            backgroundColor="white"
                            placeholder=""
                            value={step.defaultValue}
                            onChange={({ target: { value } }: any) => {
                                updateStep(stepId, 'defaultValue', value);
                            }}
                        />
                    </FormControl>
                </>
            ) : null}
            {step.operationType === 'extract-json-string-value' ? (
                <>
                    <FormControl>
                        <FormLabel>Source Var</FormLabel>
                        <VarSelect
                            value={step.sourceVarId}
                            filterByType={['STRING']}
                            onChange={(value) => updateStep(stepId, 'sourceVarId', value)}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Target Var</FormLabel>
                        <VarSelect
                            value={step.targetVarId}
                            onChange={(value) => updateStep(stepId, 'targetVarId', value)}
                        />
                    </FormControl>
                    <FormControl mt={2}>
                        <FormLabel>Item to extract</FormLabel>
                        <Input
                            backgroundColor="white"
                            placeholder=""
                            value={step.itemToExtract ?? ''}
                            onChange={({ target: { value } }: any) => {
                                updateStep(stepId, 'itemToExtract', value);
                            }}
                        />
                    </FormControl>
                </>
            ) : null}
            {step.operationType === 'map' || step.operationType === 'numeric' ? (
            <FormControl mt={2}>
                <FormLabel>Options</FormLabel>

                <Stack>
                    {step.operationType === 'map' ? (
                        <>
                            {step.valueOptions?.map((option, index) => {
                                return (
                                    <Flex key={index}>
                                        <Button
                                            backgroundColor="white"
                                            _hover={{ color: '#f0706e' }}
                                            _focus={{ backgroundColor: 'white' }}
                                            _active={{ backgroundColor: 'white' }}
                                            color={'grey'}
                                            leftIcon={<DeleteIcon />}
                                            onClick={() => {
                                                let valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                                valueOptions.splice(index, 1);
                                                updateStep(stepId, 'valueOptions', valueOptions);
                                            }}
                                        ></Button>
                                        <Input
                                            backgroundColor="white"
                                            placeholder="key"
                                            value={option.sourceValue}
                                            onChange={({ target: { value } }: any) => {
                                                let valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                                valueOptions[index].sourceValue = value;
                                                updateStep(stepId, 'valueOptions', valueOptions);
                                            }}
                                        />
                                        <Spacer minW={1} />
                                        <Input
                                            backgroundColor="white"
                                            placeholder="value"
                                            value={option.targetValue}
                                            onChange={({ target: { value } }: any) => {
                                                let valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                                valueOptions[index].targetValue = value;
                                                updateStep(stepId, 'valueOptions', valueOptions);
                                            }}
                                        />
                                    </Flex>
                                );
                            })}
                        </>
                    ) : (
                        <>
                            <TableContainer overflowX="auto">
                                <Table variant="unstyled" size="sm">
                                    <Thead>
                                        <Tr>
                                            <Th fontSize={'x-small'}>Source</Th>
                                            <Th padding={'0 !important'} fontSize={'x-small'}>
                                                operation
                                            </Th>
                                            <Th padding={'0 !important'}></Th>
                                            <Th fontSize={'x-small'}>Value</Th>
                                            <Th padding={'0 !important'}></Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {step.numericOperations?.map((option, index) => {
                                            return (
                                                <Tr key={index}>
                                                    <Td>
                                                        <VarSelect
                                                            value={option.sourceValue}
                                                            placeholder="Select Var"
                                                            filterByType={['NUMBER']}
                                                            width={285}
                                                            onChange={(value) => {
                                                                let numericOperations = JSON.parse(
                                                                    JSON.stringify(step.numericOperations),
                                                                );
                                                                numericOperations[index].sourceValue = value;
                                                                updateStep(
                                                                    stepId,
                                                                    'numericOperations',
                                                                    numericOperations,
                                                                );
                                                            }}
                                                        />
                                                    </Td>
                                                    <Td padding={'0 !important'}>
                                                        <Select
                                                            value={option.operation}
                                                            width={'100px !important'}
                                                            minW={'100px'}
                                                            color={'black'}
                                                            backgroundColor="white"
                                                            onChange={({ target: { value } }: any) => {
                                                                let numericOperations = JSON.parse(
                                                                    JSON.stringify(step.numericOperations),
                                                                );
                                                                numericOperations[index].operation = value;
                                                                updateStep(
                                                                    stepId,
                                                                    'numericOperations',
                                                                    numericOperations,
                                                                );
                                                            }}
                                                        >
                                                            <option value="" disabled={true}>
                                                                Select operation
                                                            </option>
                                                            {OPERATION.map((operation) => {
                                                                return (
                                                                    <option value={operation.operation}>
                                                                        {operation.symbol}
                                                                    </option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Td>
                                                    <Td padding={'0 !important'}>
                                                        {!['min', 'max'].includes(option.operation) ? (
                                                            <Checkbox
                                                                pl={2}
                                                                isChecked={option.isTargetVar}
                                                                onChange={({ target: { checked } }: any) => {
                                                                    let numericOperations = JSON.parse(
                                                                        JSON.stringify(step.numericOperations),
                                                                    );

                                                                    numericOperations[index].isTargetVar = checked;
                                                                    updateStep(
                                                                        stepId,
                                                                        'numericOperations',
                                                                        numericOperations,
                                                                    );
                                                                }}
                                                                disabled={option.operation == 'random'}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </Td>
                                                    <Td>
                                                        {['min', 'max'].includes(option.operation) ? (
                                                            <VStack>
                                                                <HStack>
                                                                    <Checkbox
                                                                        pl={2}
                                                                        isChecked={option.minMaxValueFirst.isFromVar}
                                                                        onChange={({ target: { checked } }: any) => {
                                                                            let numericOperations = JSON.parse(
                                                                                JSON.stringify(step.numericOperations),
                                                                            );

                                                                            numericOperations[
                                                                                index
                                                                            ].minMaxValueFirst.isFromVar = checked;
                                                                            updateStep(
                                                                                stepId,
                                                                                'numericOperations',
                                                                                numericOperations,
                                                                            );
                                                                        }}
                                                                        disabled={option.operation == 'random'}
                                                                    />
                                                                    {option.minMaxValueFirst.isFromVar ? (
                                                                        <VarSelect
                                                                            value={option.minMaxValueFirst.varId}
                                                                            placeholder="Select Var"
                                                                            filterByType={['NUMBER']}
                                                                            width={285}
                                                                            onChange={(value) => {
                                                                                let numericOperations = JSON.parse(
                                                                                    JSON.stringify(
                                                                                        step.numericOperations,
                                                                                    ),
                                                                                );
                                                                                numericOperations[
                                                                                    index
                                                                                ].minMaxValueFirst.varId = value;
                                                                                updateStep(
                                                                                    stepId,
                                                                                    'numericOperations',
                                                                                    numericOperations,
                                                                                );
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Input
                                                                            minW={'285px'}
                                                                            width={'285px'}
                                                                            placeholder="Enter value"
                                                                            type="number"
                                                                            bg="white"
                                                                            autoComplete="off"
                                                                            value={option.minMaxValueFirst.constValue}
                                                                            onChange={({ target: { value } }: any) => {
                                                                                let numericOperations = JSON.parse(
                                                                                    JSON.stringify(
                                                                                        step.numericOperations,
                                                                                    ),
                                                                                );
                                                                                numericOperations[
                                                                                    index
                                                                                ].minMaxValueFirst.constValue = value;
                                                                                updateStep(
                                                                                    stepId,
                                                                                    'numericOperations',
                                                                                    numericOperations,
                                                                                );
                                                                            }}
                                                                        />
                                                                    )}
                                                                </HStack>
                                                                <HStack>
                                                                    <Checkbox
                                                                        pl={2}
                                                                        isChecked={option.minMaxValueSecond.isFromVar}
                                                                        onChange={({ target: { checked } }: any) => {
                                                                            let numericOperations = JSON.parse(
                                                                                JSON.stringify(step.numericOperations),
                                                                            );

                                                                            numericOperations[
                                                                                index
                                                                            ].minMaxValueSecond.isFromVar = checked;
                                                                            updateStep(
                                                                                stepId,
                                                                                'numericOperations',
                                                                                numericOperations,
                                                                            );
                                                                        }}
                                                                        disabled={option.operation == 'random'}
                                                                    />
                                                                    {option.minMaxValueSecond.isFromVar ? (
                                                                        <VarSelect
                                                                            value={option.minMaxValueSecond.varId}
                                                                            placeholder="Select Var"
                                                                            filterByType={['NUMBER']}
                                                                            width={285}
                                                                            onChange={(value) => {
                                                                                let numericOperations = JSON.parse(
                                                                                    JSON.stringify(
                                                                                        step.numericOperations,
                                                                                    ),
                                                                                );
                                                                                numericOperations[
                                                                                    index
                                                                                ].minMaxValueSecond.varId = value;
                                                                                updateStep(
                                                                                    stepId,
                                                                                    'numericOperations',
                                                                                    numericOperations,
                                                                                );
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Input
                                                                            minW={'285px'}
                                                                            width={'285px'}
                                                                            placeholder="Enter value"
                                                                            type="number"
                                                                            bg="white"
                                                                            autoComplete="off"
                                                                            value={option.minMaxValueSecond.constValue}
                                                                            onChange={({ target: { value } }: any) => {
                                                                                let numericOperations = JSON.parse(
                                                                                    JSON.stringify(
                                                                                        step.numericOperations,
                                                                                    ),
                                                                                );
                                                                                numericOperations[
                                                                                    index
                                                                                ].minMaxValueSecond.constValue = value;
                                                                                updateStep(
                                                                                    stepId,
                                                                                    'numericOperations',
                                                                                    numericOperations,
                                                                                );
                                                                            }}
                                                                        />
                                                                    )}
                                                                </HStack>
                                                            </VStack>
                                                        ) : (
                                                            <>
                                                                {option.isTargetVar ? (
                                                                    <VarSelect
                                                                        value={option.targetValueVar}
                                                                        placeholder="Select Var"
                                                                        filterByType={['NUMBER']}
                                                                        width={285}
                                                                        disabled={option.operation === 'random'}
                                                                        onChange={(value) => {
                                                                            let numericOperations = JSON.parse(
                                                                                JSON.stringify(step.numericOperations),
                                                                            );
                                                                            numericOperations[index].targetValueVar =
                                                                                value;
                                                                            updateStep(
                                                                                stepId,
                                                                                'numericOperations',
                                                                                numericOperations,
                                                                            );
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <Input
                                                                        minW={'285px'}
                                                                        width={'285px'}
                                                                        placeholder="Enter value"
                                                                        type="number"
                                                                        bg="white"
                                                                        autoComplete="off"
                                                                        value={option.targetValueConst}
                                                                        onChange={({ target: { value } }: any) => {
                                                                            let numericOperations = JSON.parse(
                                                                                JSON.stringify(step.numericOperations),
                                                                            );
                                                                            numericOperations[index].targetValueConst =
                                                                                value;
                                                                            updateStep(
                                                                                stepId,
                                                                                'numericOperations',
                                                                                numericOperations,
                                                                            );
                                                                        }}
                                                                        disabled={option.operation == 'random'}
                                                                    />
                                                                )}
                                                            </>
                                                        )}
                                                    </Td>
                                                    <Td padding={'0px !important'}>
                                                        <Button
                                                            backgroundColor="white"
                                                            _hover={{ color: '#f0706e' }}
                                                            _focus={{ backgroundColor: 'white' }}
                                                            _active={{ backgroundColor: 'white' }}
                                                            color={'grey'}
                                                            leftIcon={<DeleteIcon />}
                                                            onClick={() => {
                                                                let numericOperations = JSON.parse(
                                                                    JSON.stringify(step.numericOperations),
                                                                );
                                                                numericOperations.splice(index, 1);
                                                                updateStep(
                                                                    stepId,
                                                                    'numericOperations',
                                                                    numericOperations,
                                                                );
                                                            }}
                                                        />
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </>
                    )}
                    <Button
                        backgroundColor="white"
                        size={'sm'}
                        _hover={{ backgroundColor: 'white', color: 'black' }}
                        _focus={{ backgroundColor: 'white' }}
                        _active={{ backgroundColor: 'white' }}
                        color={'grey'}
                        leftIcon={<AddIcon />}
                        onClick={() => {
                            if (step.operationType === 'map') {
                                let valueOptions = JSON.parse(JSON.stringify(step.valueOptions));
                                valueOptions.push({
                                    targetValue: '',
                                    sourceValue: '',
                                });
                                updateStep(stepId, 'valueOptions', valueOptions);
                            } else {
                                let numericOperations: any = [];
                                if (step.numericOperations) {
                                    numericOperations = JSON.parse(JSON.stringify(step.numericOperations));
                                }
                                numericOperations.push({
                                    sourceValue: '',
                                    operation: 'equal',
                                    isTargetVar: false,
                                    targetValue: 0,
                                    targetValueVar: '',
                                    minMaxValueFirst: {
                                        isFromVar: true,
                                        varId: '',
                                        constValue: '',
                                    },
                                    minMaxValueSecond: {
                                        isFromVar: true,
                                        varId: '',
                                        constValue: '',
                                    },
                                });
                                updateStep(stepId, 'numericOperations', numericOperations);
                            }
                        }}
                    >
                        Add Option
                    </Button>
                </Stack>
            </FormControl>
            ) : null}
        </Box>
    );
}

